import * as React from 'react';
import Box from '@mui/material/Box';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';

import Bs4GenericField from './Bs4GenericField';
import {Bs4ViewNumber} from '../../Bs4Components/Bs4ViewNumber';
import Bs4I18N from '../../Bs4I18N';  
import {isNullOrNaN} from '../../Bs4Components/Bs4Utils';

export default class Bs4NumberRange extends Bs4GenericField {

  text_From = Bs4I18N.getTT('From:', 'Od:', 'Bs4DateRange');
  text_To   = Bs4I18N.getTT('To:', 'Do:', 'Bs4DateRange');

  setValueBs4(value) {
    if (!value) value = {od: 0, do: 0}
    if (!value.od) value.od = 0;
    if (!value.do) value.do = 0;
    this.setValue(value);
  }

  isEmpty () {
    const value = this.getValue();
    if (!value) return true;
    if (!value.od && !value.do) return true;
    return false;
  }

  getShortValue(full) {    
    const value = this.getValue();
		return this.text_From+value?.od+', '+this.text_To+value?.do;
  }

  ViewComponentField = (props) => {
    const formField = this;
    const [value, setValue] = React.useState(() => this.getValue());
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR)
    const [errorOd, setErrorOd] = React.useState(Bs4GenericField.NO_ERROR)
    const [errorDo, setErrorDo] = React.useState(Bs4GenericField.NO_ERROR)
    const decimals = parseInt(this.props.field.decimals) || 0;
    this.refFocus = React.useRef();    


    React.useEffect(() => {
      this.notValidElementDom = (text) => {setError({error: true, helperText: text})}
      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
        const value = this.getValue();
        setValue(value);
        if (value.od > value.do) {
          setError({error: true, helperText: `${formField.text_From}${value.od} > ${formField.text_To}${value.do}`})
        } else setError(Bs4GenericField.NO_ERROR);
        const minValue = parseFloat(this.props.field.minValue);
        const maxValue = parseFloat(this.props.field.maxValue);        
        if (!isNullOrNaN(minValue) && value.od < minValue) {
          setErrorOd({error: true, helperText: value.od+'<'+minValue});
        } else if (!isNullOrNaN(maxValue) && value.od > maxValue) {
          setErrorOd({error: true, helperText: value.od+'>'+maxValue});
        } else setErrorOd(Bs4GenericField.NO_ERROR);
        if (!isNullOrNaN(minValue) && value.do < minValue) {          
          setErrorDo({error: true, helperText: value.do+'<'+minValue});
        } else if (!isNullOrNaN(maxValue) && value.od > maxValue) {
          setErrorDo({error: true, helperText: value.Do+'>'+maxValue});
        } else setErrorDo(Bs4GenericField.NO_ERROR);
      })    
    }, [error]);
    
    const handleChangeOd = (newValue) => {     
      value.od = newValue;      
      this.setValue({...value});      
    }

    const handleChangeDo = (newValue) => {     
      value.do = newValue;      
      this.setValue({...value});      
    }

    return (
      <FormControl fullWidth error={error.error} >
        {!this.props.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}
        <Box display="flex" flexDirection="row" sx={{gap: 2}}>

          <Bs4ViewNumber
            inputRef={this.refFocus}
            id={this.props.inputId}
            value={value.od}
            onValueChange={handleChangeOd}
            decimals={decimals}
            error={errorOd.error}
            helperText={errorOd.helperText}
            readOnly={formField.readOnly}
            suffix={formField.props.field.number_suffix || ''} 
          />          

          <Bs4ViewNumber
            id={this.props.inputId}
            value={value.do}
            onValueChange={handleChangeDo}
            decimals={decimals}
            error={errorDo.error}
            helperText={errorDo.helperText}
            readOnly={formField.readOnly}
            suffix={formField.props.field.number_suffix || ''} 
          />
        </Box>
        <FormHelperText>{error.helperText}</FormHelperText>
      </FormControl>    
    );
  }
}